// import {ReactComponent as WolframLogo} from '../assets/WolframLogo.svg';
// import {ReactComponent as MicrosoftLogo} from '../assets/Microsoft.svg';
import {ReactComponent as bashLogo} from '../assets/bash.svg';

const Misc = {
    title: "Tools & Misc",
    icons: [
        { icon: "logos:git-icon", name: "Git" },
        { icon: "logos:github-icon", name: "GitHub" },
        { icon: "logos:figma", name: "Figma" },
        { icon: "logos:vercel-icon", name: "Vercel" },
        { icon: "devicon:canva", name: "Canva" },
        { name: "Wolfram", icon: "vscode-icons:file-type-wolfram" },
        { icon: "devicon:r", name: "R Language" },
        { name: "Bash", icon: bashLogo, isCustom: true },
        { icon: "logos:java", name: "Java" },
        {icon: "devicon:latex", name: "LaTeX" },
        { name: "Microsoft Workspace", icon: "selfhst:microsoft-365" },
        {icon: "devicon:google", name: "Google Workspace" },
        
      ]
    }

export default Misc;